export enum TYPE_USER {
    STUDENT = "STUDENT",//นักเรียน
    EMPLOYEE = "EMPLOYEE",// บุคลากร
    MEMBER = "MEMBER" // ผู้ใช้ทั่วไป
}


export const type_user_data: { label: string, value: string }[] = [
    {
        label: "นักเรียน",
        value: TYPE_USER.STUDENT
    },
    {
        label: "บุคลากร",
        value: TYPE_USER.EMPLOYEE
    },
    {
        label: "ผู้ใช้ทั่วไป",
        value: TYPE_USER.MEMBER
    },
]